var React = require('react');

function ChevRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.4089 9.98105C12.4055 9.53285 12.2276 9.10396 11.9135 8.78505L3.6389 0.510586C2.96659 -0.164824 1.874 -0.167234 1.19859 0.505066C0.523178 1.17737 0.520758 2.26994 1.19308 2.94534L8.25026 10.0024L1.19308 17.0595C0.520768 17.7349 0.523178 18.8275 1.19859 19.4998C1.874 20.1721 2.96659 20.1697 3.6389 19.4943L11.9135 11.2198C12.2383 10.8902 12.4168 10.4437 12.4089 9.98106V9.98105Z","fill":"#041E42"}));
}

ChevRight.defaultProps = {"width":"13","height":"21","viewBox":"0 0 13 21","fill":"none"};

module.exports = ChevRight;

ChevRight.default = ChevRight;
